import {useFormik} from 'formik';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {t,} from 'i18next';
import moment from 'moment';
import {Calendar} from 'react-date-range';
import * as locales from 'react-date-range/dist/locale';
import creature_3 from '../../../../assets/img/creature_3.png';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Input from '../../../../components/bootstrap/forms/Input';
import Label from '../../../../components/bootstrap/forms/Label';
import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from '../../../../components/bootstrap/Modal_v2';
import showNotification from '../../../../components/extras/showNotification';
import {useMst} from '../../../../models';
import AttendService from '../../../../services/AttendService';
import CompanyService from '../../../../services/CompanyService';
import UserService from '../../../../services/UserService';
import Button from '../../../../components/bootstrap/Button';
import Card, {CardBody, CardFooter} from '../../../../components/bootstrap/Card';
import CustomSelect from '../../../../components/bootstrap/forms/CustomSelect';
import Icon from '../../../../components/icon/Icon';
import ThemeContext from '../../../../contexts/themeContext';
import UserReqRecordEditTimeSettingModal from '../components/UserReqRecordEditTimeSettingModal';
import Avatar from "react-avatar";
import ApprovalModalMini, {ApprovalLineEditButton} from "../../Approval/components/ApprovalModalMini";
import ApprovalLineSelectModal from '../components/modal/ApprovalLineSelectModal';
import ConfirmModal from 'components/common/ConfirmModal';
import { getPersonDisplayName, getApprovalUserValue, withApprovalLineLangs } from 'helpers/personNameI18n';
import { mergeLineCcUsers } from 'helpers/approvalCcUsers';
import { getLocalizedFieldOrI18n } from 'helpers/localizedField';

const UserReqRecordEditModal = (props) => {
	const { data, isOpen, setIsOpen, onSuccess } = props;
	const { user, company } = useMst();
	const approvalSelf = company.approvalSelf;
	const selectRef = useRef(null);
	// 마지막으로 고른 결재라인에서 들어온 참조자(결재라인을 바꿀 때 이 사람들만 교체)
	const lineCcUsersRef = useRef([]);
	const tomorrow = new Date(new Date());
	tomorrow.setDate(new Date().getDate() + 1);

	useEffect(() => { }, [data]);
	const popRef = useRef({});
	const isSubmittingRef = useRef(false);
	const [approvalList, setApprovalList] = useState([]);
	const [myEvent, setMyEvent] = useState({});
	const [chagneDateRangeYear, setChagneDateRangeYear] = useState(moment(new Date()).year());
	const [openCalendar, setOpenCalendar] = useState(false);
	const [openSelectTimeModal, setOpenSelectTimeModal] = useState(false);
	const [checkStartOrEnd, setCheckStartOrEnd] = useState('');
	const [selectedWorkDate, setSelectedWorkDate] = useState('');
	const { mobileDesign, lang } = useContext(ThemeContext);
	const [openSuccessRequestModal, setOpenSuccessRequestModal] = useState(false);
	const tr = useCallback((name) => t(`userVacation.${name}`), [t]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isOpenApprovalLineSelectModal, setIsOpenApprovalLineSelectModal] = useState(false);
	const [selectedApprovalLineTemp, setSelectedApprovalLineTemp] = useState(null);

	const refresh = async () => {
		if (['WORK', 'ATTEND'].includes(data[0]?.type)) {
			await AttendService.getLogAttend(
				0,
				moment(data[0].row?.date || data[0].start)
					.startOf('M')
					.format('YYYY-MM-DD'),
				moment(data[0].row?.date || data[0].start)
					.endOf('M')
					.format('YYYY-MM-DD'),
				company.get.id,
				'day',
				user.me.id
			).then((res) => {
				if (res?.data?.length > 0) {
					const events = res?.data[0];
					const thisEvent = events?.find((i) => i?.attend && i?.attend?.id === data[0]?.row?.id);
					setMyEvent(thisEvent);
				}
			});
		}

		await UserService.getApproval(
			company.get.id,
			{
				userId: user.id,
				departId: company.get?.departInfos[0]?.departId || '',
				option: 'up'
			}
		).then(res => {
			setApprovalList(res?.data || []);
		});
	};

	useEffect(() => {
		refresh();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const requestWork = useFormik({
		initialValues: {
			id: 0,
			attendId: data[0]?.row?.id || null,
			startDate: moment(data[0].start).format('YYYY-MM-DD'),
			startTime: data[0]?.stime ? moment(data[0].stime).format('HH:mm') : '',
			companyId: company.get.id,
			endDate: moment(data[0].start).format('YYYY-MM-DD'),
			endTime: data[0]?.etime ? moment(data[0].etime).format('HH:mm') : '',
			etc: '',
			approvailLine: [],
			approvals:[],
			isApproval: false,
			ccUsers: [],
			option: {},
		},
		validate: (values) => {
			const errors = {};

			if (values.startTime === '' || values.endTime === '') {
				errors.startTime = t('requestEditPopup.timeSettingRequired');
			}

			const startDateTime = moment(
				`${values.startDate} ${values.startTime || '00:00'}`,
				'YYYY-MM-DD HH:mm'
			);

			const endDateTime = moment(
				`${values.endDate} ${values.endTime || '00:00'}`,
				'YYYY-MM-DD HH:mm'
			);

			if (endDateTime.isBefore(startDateTime)) {
				errors.endTime = t('requestEditPopup.startAfterEnd')
			}

			const diffMinutes = endDateTime.diff(startDateTime, 'minutes');

			if (diffMinutes >= 24 * 60 || diffMinutes == 0) {
				errors.endTime = t(diffMinutes == 0 ? 'requestEditPopup.workTimeZero' : 'requestEditPopup.workTimeOver24')
			}

			if (values.approvailLine.length === 0) {
				errors.approvailLine = t('staggeredCommutePopup.approvalLineSelectionRequired');
			}
			return errors;
		},
		onSubmit: async (values) => {
			values.approvals = values.approvailLine;

			let sendData = {
				id: values.id, // 0 픽스
				attendId: values.attendId,
				startDate: values.startDate,
				startTime: values.startTime,
				companyId: values.companyId,
				endDate: values.endDate,
				endTime: values.endTime,
				etc: values.etc,
				approvals: values.approvals,
				isApproval: false,
				ccUsers: values.ccUsers,
				option: values.option,
			};

			await CompanyService.modifyWorkRecord(
				!['WORK', 'ATTEND'].includes(data[0]?.type) ? sendData : values
			).then((response) => {
				if (response?.result) {
					setOpenSuccessRequestModal(true);
					// setToggleInfoEventCanvas(false)
					// setEventAdding(false)
					// reFresh();
				}
			})
			.catch((error) => {
				showNotification(
					`근무기록변경 신청`,
					error?.message || `오류가 발생했습니다 다시 시도하세요`,
					'danger'
				);
			});
		},
	});

	const approvailLineUsers =
		requestWork?.values?.approvailLine?.flatMap(lineItem =>
			lineItem.line?.map(l => withApprovalLineLangs(l)) || []
		) || [];

	// 결재라인 버튼 클릭 이벤트
	const removeApprovalUser = (targetUserId) => {
		const nextApprovalLine =
			requestWork.values.approvailLine
				.map(container => {
					// 해당 user 제거
					const nextLine = container.line.filter(
						item => item.user.userId !== targetUserId
					);

					// line이 남아있으면 container 유지
					if (nextLine.length > 0) {
						return {
							...container,
							line: nextLine,
						};
					}

					// line이 비면 container 제거 (null 반환)
					return null;
				})
				.filter(Boolean); // null 제거

		requestWork.setFieldValue('approvailLine', nextApprovalLine);

		// 회사 지정 결재라인인 경우만 Select 초기화
		if (approvalSelf && selectRef.current) {
			selectRef.current.value = '';
		}
	};

	const newStyle = (color) => ({
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 8,
		borderWidth: 1,
		borderColor: '#D9D9D9',
		backgroundColor: 'white',
		padding: '10px 10px 10px 10px',
		marginRight: 20,
		resize: 'none',
		color: color ? '#808080' : 'black',
		// width: 250
	});

	const disableRequestBtn =
		requestWork?.values?.startTime === ''
		|| requestWork?.values?.endTime === ''
		|| requestWork?.values?.approvailLine.length === 0;

	const handleTimeSetting = (time) => {
		setOpenSelectTimeModal(true);
		setCheckStartOrEnd(time);
	}

	return (
		<>
			{/* 결재라인 지정 팝업 */}
			<ApprovalModalMini setIsOpen={setIsModalOpen} isOpen={isModalOpen} restRequest={requestWork} />

			{/* 근무 신청 성공 모달 */}
			<ConfirmModal
				isOpen={openSuccessRequestModal}
				setIsOpen={setOpenSuccessRequestModal}
				title={<>
					{t('근무 기록 변경 신청')} <span className='text-success ms-2'>{t('완료')}</span>
				</>}
				description={t('successConfirmPopup.checkApplicationStatusOnEApproval1') + ' ' + t('successConfirmPopup.checkApplicationStatusOnEApproval2')}
				confirmText={t('확인')}
				onConfirm={() => {
					setOpenSuccessRequestModal(false);
					setIsOpen(false);
					onSuccess?.();
				}}
				hideCancel={true}
			/>


			{!mobileDesign ? (
			<>
				<Modal isCentered={true} size='lg' isOpen={isOpen} setIsOpen={setIsOpen} isStaticBackdrop>
					<ModalHeader setIsOpen={setIsOpen} className='user-modal-header' style={{ paddingTop: '12px', paddingBottom: '12px' }}>
						<ModalTitle id='tour-title'>{t('근무기록 수정요청')}</ModalTitle>
					</ModalHeader>
					<ModalBody className='work-modal-body'>
						<div style={{ width: '100%', height: '58px', border: '1px solid #D9D9D9' }}>
							<div className='d-flex justify-content-center align-items-center work-title'>
								<div className='work-image-wrapper'>
									<img
										className='work-image'
										alt='avatar1'
										src={creature_3}
										style={{ width: 45, height: 45 }}
									/>
								</div>
								{getPersonDisplayName(user.me)} {getLocalizedFieldOrI18n(user?.me, 'userRank') || ''}
							</div>
							<div className='d-flex align-items-center h-100 ps-3'>
								{moment(data[0].start).format(t('requestEditPopup.workingOnDay'))}
							</div>
						</div>
						<div className='work-content-wrapper d-flex flex-wrap row'>
							<div className='work-content-left-wrapper col-md-6'>
								<div className='work-content-left text-truncate' style={{ marginTop: 20 }}>
									<div className=''>
										<FormGroup>
											<span className='work-req-vac-txt-g fw-bold'>
												{t('requestEditPopup.timeChangeSetting')}
											</span>
											<span className='text-danger fs-5'>&nbsp;*</span>
											<div className='d-flex justify-content-around mt-4 flex-wrap'>
												<div>
													<span className='text-muted fw-normal'>{t('출근')}</span>
													<div className='d-flex justify-space-around gap-2'>
														<div className='work-content-cal d-flex align-items-center work-gray-text' style={{ backgroundColor: '#D9D9D9' }}>
															<span style={{ marginLeft: '10px', marginRight: '14px' }}>
																{moment(requestWork?.values?.startDate).format('YYYY-MM-DD')}
															</span>
															<Icon icon='CalendarToday' size='lg' style={{ marginRight: '10px' }}/>
														</div>
														<div>
															<Input
																id='startTime'
																className='work-content-cal d-flex align-items-center work-gray-text'
																type='time'
																value={requestWork?.values?.startTime}
																onChange={requestWork.handleChange}
															/>
														</div>
													</div>
												</div>
											</div>
											<div className='d-flex justify-content-around mt-4'>
												<div>
													<span className='text-muted fw-normal'>{t('퇴근')}</span>
													<div className='d-flex justify-space-around gap-2'>
														<div className='d-flex align-items-center'>
															<Input
																id='endDate'
																className='work-content-cal d-flex align-items-center work-gray-text'
																type='date'
																min={moment(requestWork?.values.startDate).format('YYYY-MM-DD')}
																max={moment(requestWork?.values.startDate).add(1, 'day').format('YYYY-MM-DD')}
																value={moment(requestWork?.values?.endDate).format('YYYY-MM-DD')}
																onChange={requestWork.handleChange}
															/>
														</div>
														<div>
															<Input
																id='endTime'
																className='work-content-cal d-flex align-items-center work-gray-text'
																type='time'
																value={requestWork?.values?.endTime}
																onChange={requestWork.handleChange}
															/>
														</div>
													</div>
												</div>
											</div>

											{/* 시간설정을 하지 않았을 때 경고문구 */}
											{(requestWork?.values?.startTime === '' || requestWork?.values?.endTime === '') && (
												<div className='text-danger mt-2 d-flex align-items-center'>
													<Icon icon='InfoOutline' className='mx-2' />
													<div>{t('requestEditPopup.timeSettingRequired')}</div>
												</div>
											)}

											{/* 근무시간 입력하지 않았을 때 경고문구 */}
											{ requestWork?.errors?.endTime ? (
												<div className='text-danger mt-2'>
													<Icon icon='InfoOutline' className='mx-2' />
													{requestWork?.errors?.endTime}
												</div>
											) : null}
										</FormGroup>
									</div>
								</div>
							</div>

							<div className='work-content-right-wrapper col-md-6'>
								<div className='work-content-right'>
									{/* 결재라인 */}
									<div className='work-detail-content-wrapper flex-wrap align-items-center' style={{ marginTop: '0px' }}>
										<div className='work-detail-content-title d-flex align-items-center'>
											<span className='work-req-vac-txt-g fw-bold'>{t('결재라인')}</span>
											<span className='text-danger'>&nbsp;*</span>
										</div>

										<div className='work-detail-content'>
											{approvalSelf ? (
												/* 결재라인 회사지정인 경우 결재라인을 선택하는 콤보박스 */
												<CustomSelect
													ariaLabel='Select ApprovalLine'
													style={newStyle(requestWork?.values?.approvailLine?.length === 0)}
													list={[...approvalList]?.map((v) => ({ value: v.id, label: v.name }))}
													placeholder={t('requestEditPopup.pleaseSelectApprovalLine')}
													onChange={(e) => {
														const approval = approvalList.find((v) => parseInt(v.id) === parseInt(e.target.value));
														requestWork.setFieldValue('approvailLine', approval?.lines || approval?.line || []);
														requestWork.setFieldValue('option', approval?.option || {});
														{ const { ccUsers, lineCcUsers } = mergeLineCcUsers(requestWork.values.ccUsers, lineCcUsersRef.current, approval?.ccUsers); lineCcUsersRef.current = lineCcUsers; requestWork.setFieldValue('ccUsers', ccUsers); }
													}}
												/>
											) : (
												/* 결재라인 회사지정이 아닌 경우 결재라인을 선택하는 팝업창으로 이동 */
												<Button
													type={'button'}
													style={{
														borderRadius: 8,
													}}
													isOutline={true}
													color={'info'}
													onClick={() => {
														setIsModalOpen(true);
													}}>
													<div className='d-flex align-items-center'>
														<Icon icon='Search' size='lg' color='info' />
														<span className='custom-write-button-margin'>{tr('assign')}</span>
													</div>
												</Button>
											)}
										</div>
										{/* 결재라인 편집 버튼·경고문구는 콤보박스 아래 줄에 노출 */}
										<div className='work-detail-content ms-auto'>
											{/* 결재라인 회사지정이면 결재라인 편집 버튼 항상 노출 */}
											{approvalSelf && (
												<ApprovalLineEditButton approvalLine={requestWork?.values?.approvailLine} onClick={() => setIsModalOpen(true)} />
											)}

											{/* 결재라인을 지정하지 않았을때 경고문구 */}
											{requestWork?.values?.approvailLine?.length === 0 ? (
												<div className='text-danger my-2'>
													<Icon icon='InfoOutline' className='mx-2' />
													<span>{t('staggeredCommutePopup.approvalLineSelectionRequired')}</span>
												</div>
											) : null}
										</div>
									</div>

									{/* 결재자를 지정한 경우만 노출 */}
									{requestWork?.values?.approvailLine && requestWork?.values?.approvailLine.length > 0 && (
										<div className='user-detail-content-wrapper' style={{ marginTop: '7px' }}>
											<div className='user-detail-content-title'></div>
											<div className='rank_list'>
												{approvailLineUsers.map((user, index) => (
													<Button
														key={`approval-user-${user.userId}-${index}`}
														onClick={() => removeApprovalUser(user.userId)}
													>
													<span className="d-flex justify-content-between align-items-center">
														<span className='user_info'>
															<Avatar
																round
																textSizeRatio={0.5}
																size={25}
																name={user?.name || ''}
																src={user?.profile || null}
															/>
															<span className='user_txt'>
																<span>
																	{`${getApprovalUserValue(user)} ${getApprovalUserValue(user, 'rank') ?? ''}`}
																</span>
																<span>{getApprovalUserValue(user, 'department') || ''}</span>
															</span>
														</span>
														<Icon icon="Cancel" size="lg" />
													</span>
													</Button>
												))}
											</div>
										</div>
									)}

									{/* 참조 */}
									{/* 참조자가 있는 경우에만 노출 (참조 편집은 결재라인 편집 팝업에서) */}
									{requestWork?.values?.ccUsers?.length > 0 && (
									<>
										<div className='work-detail-content-wrapper' style={{ marginTop: '16px' }}>
											<div className='work-detail-content-title d-flex align-items-center'>
												<span className='work-req-vac-txt-g fw-bold'>{t('참조')}&nbsp;</span>
											</div>
											<div className='work-detail-content'>
												{/* 참조자 목록이 나오는 영역 */}
												<div className='d-flex flex-wrap'>
													{requestWork?.values?.ccUsers?.map((v, i) => (
														<Button
															style={{
																borderRadius: 6,
																borderWidth: 1,
																borderColor: '#D9D9D9',
																margin: 5,
																backgroundColor: '#F8F9FA',
															}}
															key={`ccUsers-${i}`}
															className='py-1 px-2'
															onClick={() => {
																const newCcUsers = [...requestWork?.values?.ccUsers];
																newCcUsers.splice(i, 1);

																requestWork.setFieldValue('ccUsers', newCcUsers);
															}}>
															<Icon icon='Visibility' size='md' style={{ color: 'grey' }} />
															<span className='mx-3'>
																{getApprovalUserValue(v)} {requestWork.values.ccUsers.length - 1 > i}
															</span>
															<Icon icon='Close' size='md' />
														</Button>
													))}
												</div>
											</div>
										</div>
									</>
									)}

									{/* 사유 */}
									<div className='work-detail-content-wrapper mt-4'>
										<div className='work-detail-content-title d-flex'>
											<span className='work-req-vac-txt-g fw-bold'>
												{t('사유')}
											</span>
										</div>
										<div className='work-detail-content' style={{ marginTop: '-4px' }}>
											<textarea
												id='etc'
												className='form-control'
												rows='3'
												style={{
													justifyContent: 'center',
													alignItems: 'center',
													borderRadius: 8,
													borderWidth: 1,
													borderColor: '#D9D9D9',
													backgroundColor: 'white',
													padding: '10px 10px 10px 10px',
													marginRight: 20,
													resize: 'none',
													color: '#808080',
												}}
												placeholder={t('requestEditPopup.inputReasonOptional')}
												value={requestWork?.values?.etc}
												onChange={requestWork.handleChange}
											/>
										</div>
									</div>

								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter className='justify-content-end'>
						<Button
							style={{
								border: '1px solid #FE637C',
								borderRadius: 7,
								backgroundColor: '#FE637C',
								color: 'white',
								padding: '10px 15px 10px 15px',
							}}
							disabled={disableRequestBtn}
							onClick={() => {
								if (isSubmittingRef.current) return;
								isSubmittingRef.current = true;
								requestWork.handleSubmit();

							}}>
							{t('근무기록 수정요청')}
						</Button>
					</ModalFooter>
				</Modal>
			</>
			) : (
			<>
				<Modal isCentered={true} size='lg' isOpen={isOpen} setIsOpen={setIsOpen} isStaticBackdrop isScrollable fullScreen="sm">
					<ModalHeader className={!mobileDesign && 'user-modal-header'}>
						<ModalTitle className='fw-bold' id='tour-title'>
							{t('근무기록 수정요청')}
						</ModalTitle>
					</ModalHeader>
					<ModalBody className='work-modal-body'>
						<Card className='custom-box-shadow rounded-2' style={{ marginBottom: '24px' }}>
							<CardBody>
								<p className='mb-0'>{t('수정일')}</p>
								<p className='text-black fw-bold mb-0 mt-2'>
									<span>{moment(data[0].start).format('MM월 DD일 dd요일 근무')}</span>
								</p>
							</CardBody>
						</Card>
						<div>
							{/* 출근시간 */}
							<FormGroup className='d-flex mt-3'>
								<div className='col-3'>
									<Label className='mt-2 fw-bold text-black'>{t('출근시간')}</Label>
									<span className='text-danger fs-3'>&nbsp;*</span>
								</div>
								<div className='col-9 text-nowrap text-truncate'>
									<div className='d-flex justify-content-between'>
										<Button
											className='d-flex align-items-center justify-content-center'
											style={{
												width: 'calc(50% - 5px)',
												borderRadius: 8,
												borderWidth: 1,
												borderColor: '#D9D9D9',
												padding: '10px',
												color: '#808080',
											}}>
											<span className='me-2'>
												{moment(requestWork?.values?.startDate).format('YYYY. MM. DD')}
											</span>
											<Icon icon='CalendarToday' size='lg' />
										</Button>
										<Button
											id='startTime'
											style={{
												width: 'calc(50% - 5px)',
												borderRadius: 8,
												borderWidth: 1,
												borderColor: '#D9D9D9',
												padding: '10px',
												color: '#808080',
											}}
											// type='time'
											// value={requestWork?.values?.startTime}
											onClick={() => {
												handleTimeSetting('START');
											}}
										>
											{
												requestWork.values.startTime
												&& moment(requestWork.values.startTime, 'HH:mm').isValid()
													? moment(requestWork.values.startTime, 'HH:mm').format('A hh:mm')
													: '-- : --'
											}
										</Button>
									</div>
								</div>
							</FormGroup>
							<FormGroup className='d-flex mt-3'>
								<div className='col-3'>
									<Label className='mt-2 fw-bold text-black'>{t('퇴근시간')}</Label>
									<span className='text-danger fs-3'>&nbsp;*</span>
								</div>
								<div className='col-9 text-nowrap text-truncate'>
									<div className='d-flex justify-content-between'>
										<Button
											id='endDate'
											className='d-flex align-items-center justify-content-center'
											style={{
												width: 'calc(50% - 5px)',
												borderRadius: 8,
												borderWidth: 1,
												borderColor: '#D9D9D9',
												padding: '10px',
												color: '#808080',
											}}
											onClick={() => {
												setOpenCalendar(true);
											}}
										>
											<span className='me-2'>
												{moment(requestWork?.values?.endDate).format('YYYY. MM. DD')}
											</span>
											<Icon icon='CalendarToday' size='lg' />
										</Button>
										<Button
											id='endTime'
											style={{
												width: 'calc(50% - 5px)',
												borderRadius: 8,
												borderWidth: 1,
												borderColor: '#D9D9D9',
												padding: '10px',
												color: '#808080',
											}}
											onClick={() => {
												handleTimeSetting('END');
											}}
										>
											{
												requestWork.values.endTime
												&& moment(requestWork.values.endTime, 'HH:mm').isValid()
													? moment(requestWork.values.endTime, 'HH:mm').format('A hh:mm')
													: '-- : --'
											}
										</Button>
									</div>
									{(requestWork?.values?.startTime === '' || requestWork?.values?.endTime === '') && (
										<div className='text-danger mt-1'>
											<Icon icon='InfoOutline' className='me-2' />
											<span>{t('시간 선택은 필수입니다')}</span>
										</div>
									)}
								</div>
							</FormGroup>

							{/* 결재라인 */}
							<FormGroup className='d-flex flex-wrap align-items-center mt-3'>
								<div className='col-3'>
									<Label className='fw-bold text-black mb-0'>{t('결재라인')}</Label>
									<span className='text-danger fs-3'>&nbsp;*</span>
								</div>
								<div className='col-9 text-nowrap'>
									{approvalSelf ? (
										/* 결재라인 회사지정인 경우 → 모달로 선택 */
										<Button
											className='btn_select_ico'
											onClick={() => {
												setSelectedApprovalLineTemp(null);
												setIsOpenApprovalLineSelectModal(true);
											}}
										>
											<span>
												{approvalList?.find((v) =>
													requestWork.values?.approvailLine?.length &&
													(v.lines || v.line || []).length === requestWork.values.approvailLine.length
												)?.name || t('requestEditPopup.pleaseSelectApprovalLine')}
											</span>
											<Icon icon='KeyboardArrowDown' size='2x' />
										</Button>
									) : (
										/* 결재라인 회사지정이 아닌 경우 결재라인을 선택하는 팝업창으로 이동 */
										<Button
											type={'button'}
											style={{
												borderRadius: 8,
											}}
											isOutline={true}
											color={'info'}
											onClick={() => {
												setIsModalOpen(true);
											}}>
											<div className='d-flex align-items-center'>
												<Icon icon='Search' size='lg' color='info' />
												<span className='custom-write-button-margin'>{tr('assign')}</span>
											</div>
										</Button>
									)}
								</div>
								{/* 결재라인 편집 버튼·경고문구·결재자 목록은 콤보박스 아래 줄에 노출 */}
								<div className='col-9 ms-auto text-nowrap'>
									{/* 결재라인 회사지정이면 결재라인 편집 버튼 항상 노출 */}
									{approvalSelf && (
										<ApprovalLineEditButton approvalLine={requestWork?.values?.approvailLine} onClick={() => setIsModalOpen(true)} />
									)}

									{/* 결재라인을 지정하지 않았을때 경고문구 */}
									{requestWork?.values?.approvailLine?.length === 0 ? (
										<div className='text-danger mt-1'>
											<Icon icon='InfoOutline' className='me-2' />
											<span>{t('staggeredCommutePopup.approvalLineSelectionRequired')}</span>
										</div>
									) : null}

									{/* 결재자를 지정한 경우만 노출 */}
									{requestWork?.values?.approvailLine && requestWork?.values?.approvailLine.length > 0 && (
										// 결재라인 버튼 목록
										<div className='mt-2 rank_list'>
											{approvailLineUsers.map((user, index) => (
												<Button
													key={`approval-user-${user.userId}-${index}`}
													onClick={() => removeApprovalUser(user.userId)}
												>
													<span className="d-flex justify-content-between align-items-center">
														<span className='user_info'>
															<Avatar
																round
																textSizeRatio={0.5}
																size={25}
																name={user?.name || ''}
																src={user?.profile || null}
															/>
															<span className='user_txt'>
																<span>
																	{`${getApprovalUserValue(user)} ${getApprovalUserValue(user, 'rank') ?? ''}`}
																</span>
																<span>{getApprovalUserValue(user, 'department') || ''}</span>
															</span>
														</span>
														<Icon icon="Cancel" size="lg" />
													</span>
												</Button>
											))}
										</div>
									)}
								</div>
							</FormGroup>

							{/* 참조자가 있는 경우에만 노출 (참조 편집은 결재라인 편집 팝업에서) */}
							{requestWork?.values?.ccUsers?.length > 0 && (
							<>
								<FormGroup className='d-flex align-items-center mt-3'>
									<div className='col-3'>
										<Label className='mb-0 fw-bold text-black'>{t('참조')}</Label>
									</div>
									<div>
										<div>
											<div className='d-flex flex-wrap'></div>
											{requestWork?.values?.ccUsers?.map((v, i) => (
												<Button
													style={{
														borderRadius: 6,
														borderWidth: 1,
														borderColor: '#D9D9D9',
														margin: 5,
														backgroundColor: '#F8F9FA',
													}}
													key={`ccUsers-${i}`}
													className='py-1 px-2'
													onClick={() => {
														const newCcUsers = [...requestWork?.values?.ccUsers];
														newCcUsers.splice(i, 1);
														requestWork.setFieldValue('ccUsers', newCcUsers);
													}}>
													<Icon icon='Visibility' size='md' style={{ color: 'grey' }} />
													<span className='mx-3'>
														{getApprovalUserValue(v)} {requestWork.values.ccUsers.length - 1 > i}
													</span>
													<Icon icon='Close' size='md' />
												</Button>
											))}
										</div>
									</div>
								</FormGroup>
							</>
							)}

							{/* 사유 */}
							<FormGroup className='d-flex mt-3'>
								<div className='col-3'>
									<Label className='mt-2 fw-bold text-black'>{t('사유')}</Label>
								</div>
								<div className='col-9'>
									<textarea
										id='etc'
										className='form-control'
										rows='3'
										style={newStyle()}
										placeholder={t('requestEditPopup.inputReasonOptional')}
										value={requestWork?.values?.etc}
										onChange={requestWork.handleChange}
									/>
								</div>
							</FormGroup>
						</div>
					</ModalBody>
					<ModalFooter className='justify-content-center flex-nowrap'>
						<Button
							color='info'
							isOutline
							className='py-3 w-100'
							onClick={() => {
								props?.setIsOpen(false);
							}}>
							<span>{t('닫기')}</span>
						</Button>
						<Button
							color='info'
							disabled={disableRequestBtn}
							onClick={() => {
								if (isSubmittingRef.current) return;
								isSubmittingRef.current = true;
								requestWork.handleSubmit();
							}}
							className='py-3 w-100'
						>
							<span>{t('수정요청')}</span>
						</Button>
					</ModalFooter>
				</Modal>


				{/* 모바일 결재라인 선택 모달 */}
				{isOpenApprovalLineSelectModal && (
					<ApprovalLineSelectModal
						isOpen={isOpenApprovalLineSelectModal}
						setIsOpen={setIsOpenApprovalLineSelectModal}
						approvalList={approvalList ?? []}
						selectedTemp={selectedApprovalLineTemp}
						setSelectedTemp={setSelectedApprovalLineTemp}
						onConfirm={(item) => {
							requestWork.setFieldValue('approvailLine', item.lines || item.line || []);
							requestWork.setFieldValue('option', item.option || {});
							const { ccUsers, lineCcUsers } = mergeLineCcUsers(requestWork.values.ccUsers, lineCcUsersRef.current, item.ccUsers);
							lineCcUsersRef.current = lineCcUsers;
							requestWork.setFieldValue('ccUsers', ccUsers);
						}}
					/>
				)}

				{/* 모바일 시간설정모달 */}
				<UserReqRecordEditTimeSettingModal
					isOpen={openSelectTimeModal}
					setIsOpen={setOpenSelectTimeModal}
					data={requestWork}
					checkStartOrEnd={checkStartOrEnd}
				/>

				{/** 모바일 달력 모달 */}
				<Modal
					size='lg'
					isOpen={openCalendar}
					setIsOpen={setOpenCalendar}
					titleId="example-title"
					isScrollable
					// isStaticBackdrop
					isBottomed
				>
					<ModalHeader setIsOpen={setOpenCalendar}>
						<ModalTitle>{t('requestOTpopup.selectDate')}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<div className='row' /* ref={popRef} */>
							<Card className='shadow-none mb-0'>
								<CardBody className=''>
									<div className=''>
										<Calendar
											locale={locales.ko}
											date={
												selectedWorkDate == ''
													? new Date(moment(requestWork?.values.startDate).format('YYYY-MM-DD'))
													: selectedWorkDate
											}
											onShownDateChange={(e) => {
												// console.log('moment(e).year()', moment(e).year())
												setChagneDateRangeYear(moment(e).year())
											}
											}
											minDate={new Date(moment(requestWork?.values.startDate).format('YYYY-MM-DD'))}
											maxDate={new Date(moment(requestWork?.values.startDate).add(1, 'day').format('YYYY-MM-DD'))}
											onChange={(item) => {
												setSelectedWorkDate(item);
											}}
										/>
									</div>
								</CardBody>
								<CardFooter className='py-0 my-0 d-flex justify-content-center align-items-center'>
									<Button
										type='button'
										color='info'
										className='col-12 py-3'
										style={{ borderRadius: 7 }}
										onClick={() => {
											if (selectedWorkDate) {
												requestWork.setFieldValue('endDate', moment(selectedWorkDate).format('YYYY-MM-DD'));
												setOpenCalendar(false);
											}
										}}>
										<span className='fw-bold'>{t('선택완료')}</span>
									</Button>
								</CardFooter>
							</Card>
						</div>
					</ModalBody>
				</Modal>
			</>
			)}
		</>
	);
};
export default UserReqRecordEditModal;
